import '../../assets/css/VideoConference.css';
import { FiVideo } from "react-icons/fi";

export default function VideoProviderSelector({ provider, setProvider }) {
  const providers = [
    { key: "zoom", label: "Zoom", icon: <FiVideo size={20} /> },
    { key: "google", label: "Google Meet", icon: <FiVideo size={20} /> },
  ];

  return (
    <div className="video-provider-selector-wrapper">
      <label className='video-provider-selector-title'>Select Platform</label>
       <div className="video-provider-selector-container">
        {providers.map((p) => {
          const isSelected = provider === p.key;

          return (
            <div
              key={p.key}
              className={`provider-card ${isSelected ? "active" : ""}`}
              onClick={() => setProvider(p.key)}
            >
              <div className="provider-icon">
                {p.icon}
              </div>

              <div className="provider-label">
                {p.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
